const { baseUri, basePath } = require('../../config');

export function getAbsoluteUrl(path: string): string {
  if (!path) return baseUri;
  if (path.startsWith(baseUri) || path.startsWith('http')) return path;

  let normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (!normalizedPath.startsWith(basePath)) {
    normalizedPath = `${basePath}${normalizedPath}`;
  }

  return `${baseUri}${normalizedPath}`;
}
